import { X } from "lucide-react";
import { UpcomingPaymentItem } from "../../../api/types";
import { getDaysUntil } from '../../../utils/daysUntil'
import { formatDate } from '../../../utils/formatDate'
import { format, parseISO } from "date-fns";
import Alert from '../../../components/Alert'

interface Props {
    onClose: () => void;
    data: UpcomingPaymentItem | null;
}

export default function PayableDetail({ onClose, data }: Props) {
    if (!data) {
        return (
            <Alert subtitle={""} />
        )
    }

    const { vendor, total_amount, metadata, line_items, } = data.data;

    const amount = `- $${total_amount.toLocaleString(undefined, { minimumFractionDigits: 2 })}`;
    const initials = vendor.name?.charAt(0).toUpperCase();
    const formattedDate = formatDate(data.data.recurring_info.schedule.next_date);
    const dueInDays = getDaysUntil(data.data.recurring_info.schedule.next_date);

    const category = line_items?.[0]?.account?.name || "—";

    return (
        <div className="modal-container">
            <div className="bg-white rounded-xl w-full max-w-xl p-8 border relative">

                {/* Close Button */}
                <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-black">
                    <X size={20} />
                </button>

                {/* Header */}
                <div className="text-xl font-semibold mb-5">{amount}</div>
                <div className="flex items-center gap-3 mb-1">
                    <div className="logo-container">
                        {initials}
                    </div>
                    <div>
                        <div className="">{vendor.name}</div>
                        <div className="text-sm text-gray-500">{formattedDate}</div>
                    </div>
                </div>

                {/* Status Section */}
                <div className="grid grid-cols-3 gap-4 mt-6">
                    <div>
                        <div className="text-sm text-gray-500">Status</div>
                        <div>Pending</div>
                    </div>
                    <div>
                        <div className="text-sm text-gray-500">Category</div>
                        <div>{category}</div>
                    </div>
                    <div>
                        <div className="text-sm text-gray-500">Tags or Remarks</div>
                        <div className="mt-1">
                            <span className="tag-1">{category}</span>
                        </div>
                    </div>
                </div>

                {/* Summary Section */}
                <div className="font-semibold mb-2 mt-5">Summary</div>
                <div className="grid grid-cols-3 gap-4">
                    <div>
                        <div className="text-sm text-gray-500">Payment mode</div>
                        <div>-</div>
                    </div>
                    <div>
                        <div className="text-sm text-gray-500">Account No.</div>
                        <div>-</div>
                    </div>
                </div>

                {/* Details Section */}
                <div className="font-semibold mt-5 mb-2">Details</div>
                <div className="grid grid-cols-3 gap-4">
                    <div>
                        <div className="text-sm text-gray-500">Due in</div>
                        <div className={`${dueInDays < 0 && 'text-red-500'}`}>{dueInDays} days</div>
                    </div>
                    <div>
                        <div className="text-sm text-gray-500">Documents</div>
                        <div>-</div>
                    </div>
                    <div>
                        <div className="text-sm text-gray-500">Reminders</div>
                        <div>-</div>
                    </div>
                </div>
                <div className="w-full text-center mt-8">
                    <button className="button-1 !w-48">
                        Save
                    </button>
                </div>
            </div>
        </div>
    );
}
